$(document).ready(function(){
  $('.featured-products__slider').slick({
    infinite: true,
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: '<div class="arrow-right"><img src="//shop.tootsie.com/cdn/shop/t/49/assets/circle-chevron-right-solid.png?v=82522999196213844781782507775"></div>',
    prevArrow: '<div class="arrow-left"><img src="//shop.tootsie.com/cdn/shop/t/49/assets/circle-chevron-left-solid.png?v=136056545354490234421782507775"></div>',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          dots: true
        }
      }
    ]
  });

  $(".featured-products__thumbnail").click(function(){
    $(".featured-products__thumbnail").removeClass("active");
    $(this).addClass("active");
    var i = $(this).data("index");
    var color = $(this).data("color");
    $('.featured-products__slider').slick('slickGoTo', i);
    var section = $(this).data("section");
    var image = $(this).data("image");
    $("#section-"+section).css({"background": "url('"+image+"') no-repeat", "background-size": "cover", "background-position": "center"});
  });

  $('.featured-products__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $(".featured-products__thumbnail").removeClass("active");
    $(".featured-products__thumbnail[data-index='"+nextSlide+"']").addClass("active");
    var color = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("color");
    var section = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("section");
    var image = $(".featured-products__thumbnail[data-index='"+nextSlide+"']").data("image");
    $("#section-"+section).css({"background": "url('"+image+"') no-repeat", "background-size": "cover", "background-position": "center"});
  });

  if($(window).width() < 481){
    var w = $(".collection-grid__wrapper .grid-product").width();
    $(".ui-selectmenu-menu .ui-menu").css("max-width", w);
  }
});

function removeItem(key){
  $(".cart__item[data-key='"+key+"'] .js-qty__num").val(0).trigger("change");
  $(".cart__item[data-key='"+key+"'] .js-qty__adjust--minus").trigger("click");
}

// Prevent native form submission on QUICK ADD forms only (let AJAX handle it)
document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('submit', function(e) {
    var form = e.target;
    // Only target quick-add forms, not PDP forms
    if (form.classList.contains('quick-add-to-cart')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
});






